<template>
  <div v-if="isAllowedComment">
    <div class="m-pc-comment-list" v-if="list.length > 0">
      <div class="comment-list-item" v-for="item in list" :key="item.commentId">
        <div class="item-head">
          <img
            :src="
              item.createrPic ||
                require('../assets/images/img-head-default.jpg')
            "
            alt=""
          />
        </div>
        <div class="item-comment">
          <div class="item-name">{{ item.creator }}</div>
          <div class="item-content">
            {{ getEmojiCN(item.content) }}
          </div>
          <div class="item-footer">
            <div class="footer-left">
              <span class="item-time">{{ item.timeStr }}</span>
              <span
                class="item-delete"
                v-if="enableDelete && item.deleted"
                @click="deleteComment(item)"
                ><span class="icontemp delete"></span>删除</span
              >
            </div>
            <div class="footer-right">
              <span
                class="icontemp dianzan"
                v-if="enableLike"
                :class="{ 'is-like': item.isLike == 0 }"
                @click="like(item)"
              ></span
              ><span v-if="enableLike" class="item-num">{{
                item.likeNum
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comment-no-data" v-if="list.length == 0">
      目前还没有评论，等你发挥！
    </div>
    <Pager
      :page-index="currentPage"
      :total="count"
      :page-size="pageSize"
      v-if="count > pageSize"
      @change="pageChange"
    ></Pager>
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
import service from "../services/article";
import Pager from "../components/Pager";
import { articleId, isSetting, emojiCN } from "../common/sbase";
import { commentListData } from "../common/settingData";
export default {
  name: "Comment",
  data() {
    return {
      list: [], //列表
      isAllowedComment: false, //是否显示评论内容
      info: {},
      pageSize: 10, //每页显示10条数据
      currentPage: 1, //当前页码
      count: 0, //总记录数
      enableDelete: false, //评论是否可以删除
      enableLike: false,
      likeSubmitting: false,
      userInfo: {}
    };
  },
  components: { Pager },
  created() {
    $subscriber.subscribe("article-info", info => {
      this.info = info;
      this.isAllowedComment = info.isAllowedComment == 1;
      if (this.isAllowedComment) {
        if (!isSetting) {
          this.getList();
        } else {
          this.list = commentListData;
          this.count = 569;
          this.enableDelete = true;
          this.enableLike = true;
          $subscriber.emit("comment-count", this.count);
          $subscriber.emit("topic-config", { postIdentity: 1 });
        }
      }
    });
    $subscriber.subscribe("user-info", info => {
      if (info) {
        this.userInfo = info;
      }
    });
    $subscriber.subscribe("get-comment-list", () => {
      this.currentPage = 1;
      this.getList();
    });
  },
  methods: {
    getList() {
      if (this.isAllowedComment) {
        const param = {
          tenantId: this.info.tenantId,
          subVersionId: articleId,
          commentId: 0,
          start: (this.currentPage - 1) * this.pageSize,
          num: this.pageSize,
          topicId: this.info.topicId,
          sess: this.userInfo.session || "",
          openId: this.userInfo.openId || "",
          cookieId: this.userInfo.globalUserId
        };
        service.getCommentList(param).subscribe(res => {
          this.list = res.content.items;
          this.count = res.content.total;
          this.enableDelete = res.content.topicData.enableDelete == 1;
          this.enableLike = res.content.topicData.enableLike == 1;
          $subscriber.emit("comment-count", this.count);
          $subscriber.emit("topic-config", {
            ...res.content.topicData,
            ...{ tenantId: this.info.tenantId }
          });
        });
      }
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    deleteComment(item) {
      // let self = this;
      let param = {
        commentId: item.commentId,
        cookieId: this.userInfo.globalUserId,
        globalUserId: this.userInfo.globalUserId,
        openId: this.userInfo.openId || "",
        sess: this.userInfo.session,
        topicId: item.topicId
      };
      service.deleteComment(param).subscribe(data => {
        if (data.result == 0) {
          this.getList();
        }
      });
    },
    like(item) {
      // let self = this;
      if (item.isLike == 0) {
        return;
      }
      if (this.likeSubmitting) {
        return;
      }
      this.likeSubmitting = true;
      let param = {
        commentIds: [item.commentId],
        cookieId: this.userInfo.globalUserId,
        globalUserId: this.userInfo.globalUserId,
        openId: this.userInfo.openId || "",
        sess: this.userInfo.session || ""
      };
      service.commentLike(param).subscribe(data => {
        if (data.result == 0) {
          item.likeNum = parseInt(item.likeNum) + 1;
          item.isLike = 0;
          this.likeSubmitting = false;
        }
      });
    },
    getEmojiCN(input) {
      return emojiCN(input);
    }
  }
};
</script>
